import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import { RenderDirection } from './container'
const styles = require('./styles.scss')

export interface TrustedPartner {
  logoUrl: string
  name: string
  uuid?: string
}

export interface TrustedPartners {
  direction?: RenderDirection
  partners: TrustedPartner[]
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrustedPartners = ({ partners = [], direction = RenderDirection.ROW }: TrustedPartners): JSX.Element => (
  <div className={classnames(styles.content)}>
    <h4 className={classnames(styles.trustedPartnersHeader)}>Our Trusted Partners</h4>
    <div
      id="trusted-partner-container"
      className={classnames(
        styles.trustedPartnersContainer,
        css`
          flex-direction: ${direction};
        `,
      )}
    >
      {partners.map((partner) => (
        <img key={partner.uuid} alt={partner.name} src={partner.logoUrl} />
      ))}
    </div>
  </div>
)
